import { BorrowerType } from 'constants/loanApplication';

import { DeliveryMethod } from './ecdEstimate.constants';

export const SignerType = {
  PRIMARY_BORROWER: 'PRIMARY_BORROWER',
  CO_BORROWER: 'CO_BORROWER',
  NBE: 'NBE',
};

export const SIGNER_TYPE_LABEL = {
  [SignerType.PRIMARY_BORROWER]: 'Borrower',
  [SignerType.CO_BORROWER]: 'Co-borrower',
  [SignerType.NBE]: 'NBE · signs only',
};

export const SecondFactorType = {
  SSN: 'SSN',
  ZIP: 'ZIP',
};

export const EConsentStatus = {
  CAPTURED: 'CAPTURED',
  PENDING: 'PENDING',
  NOT_APPLICABLE: 'NOT_APPLICABLE',
};

export const EConsentPartyType = {
  PRIMARY_BORROWER: 'PrimaryBorrower',
  CO_BORROWER: 'CoBorrower',
  NON_BORROWER: 'NonBorrower',
};

export const IntentToProceedStatus = {
  NOT_YET_CAPTURED: 'NOT_YET_CAPTURED',
  CAPTURED: 'CAPTURED',
};

export const NBE_SIGNER_KEY_PREFIX = 'nbe';
export const BORROWER_SIGNER_KEY_PREFIX = 'borrower';

export const DEFAULT_DELIVERY_METHOD = DeliveryMethod.ESIGN;

export const SIGNER_TYPE_BY_BORROWER_TYPE = {
  [BorrowerType.PRIMARY]: SignerType.PRIMARY_BORROWER,
  [BorrowerType.COBORROWER]: SignerType.CO_BORROWER,
  [BorrowerType.SPOUSE]: SignerType.CO_BORROWER,
};

export const SSN_LAST4_LENGTH = 4;

export const ESIGN_ONLY_DELIVERY_DISCLAIMER =
  "Email and identity verification come from each borrower's record and are what the " +
  'disclosures are sent with — to correct them, update the borrower before preparing ' +
  'disclosures, or use the per-signer remediation actions on the Disclosures tab after ' +
  'sending. The package is delivered electronically; choosing Mail is your plan to mail ' +
  'printed copies and record it with Mark as mailed on the Disclosures tracker after sending.';

export const MAIL_PROVIDER_DELIVERY_DISCLAIMER =
  "Email and identity verification come from each borrower's record and are what the " +
  'disclosures are sent with — to correct them, update the borrower before preparing ' +
  'disclosures, or use the per-signer remediation actions on the Disclosures tab after ' +
  'sending. Choosing Mail sends a physical letter through your configured mail provider — its ' +
  'delivery status is then tracked automatically on the Disclosures tab, instead of relying on ' +
  'Mark as mailed.';
